import { Card } from './styled'
import { LoginCardProps } from './types'

const LoginCard = ({ maxWidth, children }: LoginCardProps) => {
  return <Card maxWidth={maxWidth}>{children}</Card>
}

export default LoginCard
